const selectors = {
  configurationValues: (state) => state.configuration.configurationValues,
  submitEditStatus: (state) => state.configuration.submitEditStatus,
  getConfigurationSettingsStatus: (state) =>
    state.configuration.getConfigurationSettingsStatus,
};

export { selectors };
